import React from "react";
import { MapContainer, TileLayer, Polyline, CircleMarker, Popup, Marker } from "react-leaflet";
import L from "leaflet";
import { useLang } from "@/context/LangContext";

// Custom icon: small square stamp
const stationIcon = L.divIcon({
  className: "cammino-station-icon",
  html: `<div style="
    width:26px;height:26px;
    background:#C99B4A;
    color:#1A1A1A;
    border:2px solid #3E5F44;
    border-radius:2px;
    display:flex;align-items:center;justify-content:center;
    font-family:'Cormorant Garamond',serif;
    font-size:14px;font-weight:700;
    transform:rotate(-6deg);
    box-shadow:0 2px 6px rgba(0,0,0,0.25);
  ">◆</div>`,
  iconSize: [26, 26],
  iconAnchor: [13, 13],
});

const InteractiveMap = ({ polyline, polylineSouth, polylineKamarina, stations, height = "500px" }) => {
  const { t, lang } = useLang();
  if (!polyline || !stations) return null;

  const center = [37.0, 14.95];

  return (
    <div
      data-testid="interactive-map"
      className="relative w-full overflow-hidden rounded-sm border border-carrubo/20"
      style={{ height }}
    >
      <MapContainer center={center} zoom={9} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {/* North section: Catania → Siracusa */}
        <Polyline positions={polyline} pathOptions={{ color: "#3E5F44", weight: 4, opacity: 0.85 }} />
        <Polyline positions={polyline} pathOptions={{ color: "#C99B4A", weight: 2, opacity: 0.9, dashArray: "8, 12" }} />
        {/* South section: Ferla → Noto → Modica → Ragusa */}
        {polylineSouth && polylineSouth.length > 1 && (
          <>
            <Polyline positions={polylineSouth} pathOptions={{ color: "#3E5F44", weight: 4, opacity: 0.85 }} />
            <Polyline positions={polylineSouth} pathOptions={{ color: "#C99B4A", weight: 2, opacity: 0.9, dashArray: "8, 12" }} />
          </>
        )}
        {/* Coastal branch: Modica → Kamarina */}
        {polylineKamarina && polylineKamarina.length > 1 && (
          <Polyline positions={polylineKamarina} pathOptions={{ color: "#8A5B2E", weight: 3, opacity: 0.8, dashArray: "4, 8" }} />
        )}
        {stations.map((s) => (
          <Marker key={s.slug} position={[s.lat, s.lng]} icon={stationIcon}>
            <Popup>
              <div className="font-sans">
                <div className="font-serif text-lg text-carrubo font-semibold">{s.name}</div>
                {s.year_closed && (
                  <div className="text-xs text-grafite-soft mt-1 italic">
                    {lang === "it" ? "Ex stazione ferroviaria" : "Former railway station"} · {s.year_closed}
                  </div>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default InteractiveMap;
